// Colocated Driver.js tour for MyActivity. Fires on first visit and walks
// the viewer through the three tabs (Statement, Disbursements, Payouts).

import { buildFaqOutroSteps } from '../../hooks/faqOutroSteps';

export const MY_ACTIVITY_TOUR_ID = 'my-activity-v10';

const TAB_SWITCH_ANIMATION_MS = 200;

const clickTabAndAdvance = (tabSelector) => (element, step, opts) => {
    const tabButton = document.querySelector(tabSelector);
    if (tabButton) {
        tabButton.click();
        window.setTimeout(() => opts.driver.moveNext(), TAB_SWITCH_ANIMATION_MS);
    } else {
        opts.driver.moveNext();
    }
};

export const buildMyActivityTourSteps = ({ navigate, hasTransactionPin, completedTourIds = [] }) => [
    {
        title: 'Every move your wallet has made',
        description: 'Anything that touched your wallet lives here. Use the three tabs to flip between your statement, the disbursements you received, and the payouts you sent.',
    },
    {
        element: '[data-tour="my-activity-statement-tab"]',
        title: 'Statement',
        description: 'Money in and money out, side by side in date order. Reach for this when you need to reconcile a balance or export a period for your records.',
        side: 'bottom',
        align: 'start',
        onNextClick: clickTabAndAdvance('[data-tour="my-activity-disbursements-tab"]'),
    },
    {
        element: '[data-tour="my-activity-disbursements-tab"]',
        title: 'Disbursements',
        description: 'Every top-up that landed in your wallet, with the amount and when it arrived. Use the filters to zero in on a specific day or sender.',
        side: 'bottom',
        align: 'start',
        onNextClick: clickTabAndAdvance('[data-tour="my-activity-payouts-tab"]'),
    },
    {
        element: '[data-tour="my-activity-payouts-tab"]',
        title: 'Payouts',
        description: 'Every payment you sent out, with its status: successful, pending, or failed. Filter by date, status, or recipient to find one fast.',
        side: 'bottom',
        align: 'start',
    },
    ...buildFaqOutroSteps({ navigate, hasTransactionPin, completedTourIds }),
];
